export default "__VITE_ASSET__BbJlkJCW__"